import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid2';
import InputLabel from '@mui/material/InputLabel';
import { useContext } from 'react';
import { FormContainer, useForm } from 'react-hook-form-mui';
import { APIContext } from '../../Contexts/APIContext';
import ValidatedTextField from '../../Utilities/Forms/ValidatedTextField';
import CreateSiteViewModel from './ViewModels/CreateSiteViewModel';
import SiteTableRowViewModel from './ViewModels/SiteTableRowViewModel';


interface IProps {
    open: boolean;
    onClose: (refresh: boolean) => void;
    orgId: string;
    refreshData: () => void;
    site: SiteTableRowViewModel | null;
}

export default function CreateEditSiteDialog(props: IProps) {
    const { post, showMessage, loading } = useContext(APIContext);
    const { open, onClose } = props;

    const formContext = useForm<CreateSiteViewModel>({
        defaultValues: new CreateSiteViewModel(props.site),
    });

    const {  reset } = formContext;
    const onSucess = () => {
        onClose(true);
        showMessage('success', props.site == null ? "Site Created successfully" : "Site Updated successfully");
    }

    const submit = async (form: any) => {
        if (props.site == null) {
            form.organisationId = props.orgId;
            await post("OrganisationSite", `CreateSite`, form, onSucess);
        }
        else {
            await post("OrganisationSite", `UpdateSite`, form, onSucess);
        }
        props.refreshData();
    }

    const checkCloseDialog = async () => {
        onClose(true);
        reset(new CreateSiteViewModel());
    }

    return (
        <Dialog
            open={open}
            onClose={() => checkCloseDialog()}
            maxWidth="xs"
            fullWidth>
            <FormContainer
                onSuccess={submit}
                formContext={formContext}
            >
                <DialogTitle>{props.site == null ? "Add Site" : "Edit Site"}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid size={12}>
                            <InputLabel shrink>Office Name</InputLabel>
                            <ValidatedTextField name="officeName" disabled={loading} />
                        </Grid>
                        <Grid size={12}>
                            <InputLabel shrink>Town</InputLabel>
                            <ValidatedTextField name="town" disabled={loading} />
                        </Grid>
                        <Grid size={12}>
                            <InputLabel shrink>Region</InputLabel>
                            <ValidatedTextField name="region" disabled={loading} />
                        </Grid>
                        <Grid size={12}>
                            <InputLabel shrink>Country</InputLabel>
                            <ValidatedTextField name="country" disabled={loading} />
                        </Grid>
                    </Grid>
                    <DialogActions>
                        <Button disabled={loading} variant="contained" type="submit">Confirm</Button>
                        <Button disabled={loading} onClick={() => checkCloseDialog()} color="error">Cancel</Button>
                    </DialogActions>
                </DialogContent>
            </FormContainer>
        </Dialog >
    );
}